import React, { useRef, useEffect } from 'react';

interface ImageProps {
  src: string;
  alt?: string;
  dataHook?: string;
  className?: string;
  onLoad?: () => void;
  onLoadStart?: () => void;
  lazyLoad?: boolean;
}

export const Image: React.FC<ImageProps> = ({
  src,
  alt,
  dataHook,
  onLoad,
  onLoadStart,
  className,
  lazyLoad = true,
}) => {
  const imageRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    if (imageRef.current && !imageRef.current.complete && onLoadStart) {
      onLoadStart();
    }
  }, [onLoadStart, src]);

  return (
    <img
      src={src}
      alt={alt}
      data-hook={dataHook}
      loading={lazyLoad ? 'lazy' : 'eager'}
      onLoad={onLoad}
      ref={imageRef}
      className={className}
    />
  );
};
